export default [
    'AMERICAN SAMOA',
    'FEDERATED STATES OF MICRONESIA',
    'MARSHALL ISLANDS',
    'PALAU'
]

// contains states which have no counties